<template>
<div class="site-header" style="padding:0;">
   <!--mobile -->
   
   <div class="row yo-text-n" v-if="$teras.app.device!='desktop' && $teras.app.device!='tablet'">

      <!--
      <div class="col s2"><img src="../assets/bm-round.png" style="height:40px;"/></div>
      <div class="col s8 arnoprodisplay yo-color-primary yo-text-xxxl yo-align-center " style="line-height:40px;">Biomedia Eventi</div>
      -->
      <div class="col s11m yo-align-right"><a class="button " v-on:click="$teras.event.emit('sidebarToggle')" ><i class="material-icons yo-color-primary">menu</i></a></div>
      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>


  <!-- desktop -->
   <div class="row vpad yo-text-n" v-if="$teras.app.device!='mobile'">
      <div class="col s9 offset-s3">
         <div class="top-menu row pad yo-text-s">
            <div class="col s1m"><a href="https://www.biomedia.net/">home</a></div>
            <div class="col s2"><a href="https://www.biomedia.net/chi-siamo/">chi siamo</a></div>
            <div class="col s4 yo-spacing-s"><a href="https://www.biomedia.net/eventi">calendario corsi e congressi</a></div>
            <div class="col s2m yo-spacing-s"><a href="https://www.biomedia.net/societa-scientifiche/">società scientifiche</a></div>
            <div class="col s2"><a href="https://www.biomediashop.net/">biomedia editore</a></div>

         </div>
      </div>
    </div>
    <div class="row pad yo-text-n" >
   
      <div class="col s1m yo-hidden-phone"><img src="../assets/bm-round.png" style="width:100%;"/></div>

      <div class="col s12 m10m ">

        <div class="row arnoprodisplay" style="">
            <div class="col s11 yo-text-small-caps" style="font-size:4.2rem;height:70px;line-height:110px;padding-left:14px;letter-spacing: .1rem;">BioMedia</div>
            <div class="col s1 yo-text-small-caps yo-align-right" style="font-size:2.2rem;height:70px;line-height:110px;padding-left:14px;letter-spacing: .1rem;" v-if="$route.meta.lang">
             
            <img src="../assets/ico-eng.png" @click="$lang.change('en')" v-if="$teras.lang=='it'" style="height:18px;"/>
            <img src="../assets/ico-ita.png" @click="$lang.change('it')" v-if="$teras.lang=='en'" style="height:18px;"/>

            </div>

            <div class="col s12 white yo-bg-color-secondary " >
            <div class="yo-text-bold " style="font-size:2.2rem;letter-spacing: 1.2rem;line-height:36px;padding-top:4px;padding-left:17px;">{{$teras.page.sezione}}</div>
            <router-link v-if="$route.path!='/home'" to="/" class="yo-text-m white " style="font-family:'Ebrima';float:right;line-height:40px;letter-spacing: initial;padding-right:20px;">{{$lang.g('tornaCalendario')}}</router-link>
            </div>
            
         </div>
      </div>

      
   </div>

   
</div>
</template>

<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{
   overflow:hidden;
}.site-header > .row > div{
     
}.site-header .top-menu a{
   color:#ffffff;
   background:#379EC2;
   display:block;
   font-weight:bold;
   margin-left:0;
   text-align:center;
   line-height:34px;  
   height:35px;  
}.site-header .top-menu a:hover{
   background-color:#0D1B3B;
   color:#379EC2;
}.site-header .top-menu a:last-child{
   /*margin-right:0;*/
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 40px;
    height: 40px;
    font-size: 3.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Site-header.vue